<div
    class="navbar-top"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
>
    <div class="logo"  *ngIf="!logo">
        <img  class="logo-icon" src="assets/images/logos/clinic_all.png" />
        <!-- <span class="logo-text secondary-text"> {{ nomeFantasia.value  }}</span> -->
    </div>
    <div class="logo" *ngIf="logo" >
        <img *ngIf="logo"  class="logo-clinic" [src]="logo" style="height: 48px; max-width: 100%; border-radius: 20px;"/>
    </div>
    

    <div class="buttons">
        <button
            mat-icon-button
            class="toggle-sidebar-folded"
            (click)="toggleSidebarFolded()"
            fxHide.lt-lg
        >
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button
            mat-icon-button
            class="toggle-sidebar-opened"
            (click)="toggleSidebarOpened()"
            fxHide.gt-md
        >
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>
    </div>
    
</div>

<div
    class="navbar-scroll-container"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
>
    <div
        class="user"
        fxLayout="column"
        [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
    >
        <div class="p username" >{{ nomePaciente.value }} </div>
        
        <div class="h5 email hint-text mt-8" > {{ email.value }}  </div>
        
        <div
            class="avatar-container"
            [ngClass]="fuseConfig.layout.navbar.primaryBackground"
        >
            <img class="avatar" src="assets/images/avatars/profile.jpg" />
        </div>
    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>
</div>
